const initDataAttributeName = 'data-event-init';

function hasGoogleAnalytics() {
  return 'gtag' in window;
}

const bpLoginQueryStringKey = 'bplogin';

export function trackLoginEvent() {
  const searchParams = new URLSearchParams(window.location.search);

  if(searchParams.get(bpLoginQueryStringKey) === 'success') {
    trackGoogleEvent({action: "Login Success", category: "Base Platform"})
  }
}

export function trackGoogleEvent({action, label, value, category}) {
  if(action.length > 40) {
    console.warn('Event name is longer than 40 characters. GA4 ignores events over this limit!');
    action = action.substring(0, 40);
  }

  console.log(`tracking event ${action}, label: ${label}, value: ${value}, category: ${category}`);

  if (hasGoogleAnalytics()) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });

    console.log('sent ga event...');
  }
  else {
    console.log('skipped sending ga event because ga is not available');
  }
}

export function initPageElements() {
  createEventHandlersForTagsRequiringCustomHandling(document);

  document.body.addEventListener('htmx:afterSwap', function(evt) {
    createEventHandlersForTagsRequiringCustomHandling(document);
  });

  document.body.addEventListener('htmx:oobAfterSwap', function(evt) {
    createEventHandlersForTagsRequiringCustomHandling(document);
  });
}

function getEventValueFromElement(element) {
  if(element.tagName === 'INPUT' && element.type === 'checkbox') {
    return `${element.value} - ${element.checked ? "Checked" : "Unchecked"}`;
  }

  return element.value;
}

function getLabelForElement(element) {
  let getValueFromMe = element.getAttribute('data-event-label-from-my-value');

  return getValueFromMe && getValueFromMe === "true"
    ? getEventValueFromElement(element)
    : element.getAttribute('data-event-label');
}

function createEventHandlerForElement(eventType, eventElement) {
  eventElement.addEventListener(eventType, (evt) => {
    const {currentTarget} = evt;
    const eventAction = currentTarget.getAttribute('data-event-action');

    if (eventAction) {
      const event = {
        action: eventAction,
        label: getLabelForElement(currentTarget),
        value: currentTarget.getAttribute('data-event-value'),
        category: currentTarget.getAttribute('data-event-category')
      };

      trackGoogleEvent(event);
    }
  });

  eventElement.setAttribute(initDataAttributeName, 'true');
}

function createEventHandlersForTagsRequiringCustomHandling(element) {
  Array.from(element.querySelectorAll(`[data-event-action]:not([${initDataAttributeName}])`)).forEach((eventElement) => {

    let eventType;
    switch (eventElement.tagName) {
      case 'FORM':
        eventType = 'submit';
        break;
      case 'SELECT':
        eventType = 'change';
        break;
      case 'INPUT':
        eventType = eventElement.type === 'checkbox' ? 'change' : 'click';
        break;
      default:
        eventType = 'click';
    }

    createEventHandlerForElement(eventType, eventElement);
  });
}
